import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Tooltip,
  IconButton,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import SendIcon from '@mui/icons-material/Send';
import { Delete } from '@mui/icons-material';
import { getImageSource } from '../apiRewards/routes';
import { messageShow } from '../../common/api/actions';
import { removeReward, publishToggle } from '../apiRewards/actions/mutation';
import dayjs from 'dayjs';

class RewardCard extends Component {

  onDeleteReward = async () => {
    const { reward, removeReward, refresh, messageShow } = this.props;
    const confirmDelete = window.confirm("Are you sure you want to delete this reward?");
    if (!confirmDelete) return;

    try {
      const removedData = await removeReward({ rewardIds: [reward._id] });

      if (removedData.some(res => res.success)) {
        messageShow("Reward deleted successfully.");
        refresh();
      } else {
        messageShow("Failed to delete the reward.");
      }
    } catch (error) {
      messageShow("An error occurred while deleting the reward.");
      console.error("Error deleting Reward: ", error)
    }
  };

   onPublishToggle = rewardId => async event => {
      const isPublished = event.target.checked
      let check = window.confirm(`Are you sure you want to ${isPublished ? 'publish' : 'unpublish'} this reward?`)

      if (check) {
        const { publishToggle, messageShow, refresh } = this.props

        try {
          const { data } = await publishToggle({ rewardId, isPublished })
          if (data.success) {
            messageShow(data.message)
            refresh();
          }
        } catch (error) {
          console.error(`Error ${isPublished ? 'publishing' : 'unpublishing'} reward: `, error)
          messageShow('Some error occurred. Please try again.')
        }
      }
    }

  render() {
    const { reward, currencySymbol, permissions, onClone, onOpenMessagingDialog } = this.props;
    const isExpired = reward.isExpired;

    return (
      <Card sx={{ maxWidth: 400, m: 1, cursor: permissions.canEdit ? 'pointer' : 'default' }} onClick={() => permissions.canEdit && this.props.history.push(`/rewards/edit/${reward._id}`)}>
        <CardMedia
          component="img"
          loading='lazy'
          height="160"
          image={getImageSource(reward.image)}
          alt={reward.rewardName}
          onError={(e) => {
            e.target.src = getImageSource();
          }}
        />
        <CardContent>
          <Tooltip title={reward.rewardName} arrow>
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{
                width: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'block',
              }}
            >
              {reward.rewardName}
            </Typography>
          </Tooltip>
          <Typography variant="body2" color="text.secondary">
            Earned Points: {reward.earnedPoints}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Discount: {reward.onlineDeals.discountPercentage}%
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Min Order: {currencySymbol}
            {reward.onlineDeals.minOrderAmount || 0}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Voucher Code: {reward.voucherCode}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Expiry Date: {dayjs(reward.expiryDate).format("DD-MM-YYYY")}
          </Typography>
        </CardContent>
        <CardContent>
          <Tooltip title="Delete">
            <IconButton
              disabled={isExpired || !permissions.canDelete}
              color="error"
              onClick={(e) => {
                e.stopPropagation();
                this.onDeleteReward();
              }}
            >
              <Delete />
            </IconButton>
          </Tooltip>
          <FormControlLabel
            control={
            <Checkbox
              checked={reward.isPublished}
              onChange={this.onPublishToggle(reward._id)}
              onClick={(e) => e.stopPropagation()}
              disabled={!permissions.canEdit}
              sx={{ ml: 1}}
            />
            }
            label="Published"
          />
          <Tooltip title="Create Notification" arrow>
            <span>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onOpenMessagingDialog(reward._id);
                }}
                color="primary"
                disabled={isExpired || !permissions.canEdit}
              >
                <SendIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Clone" arrow>
            <span>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onClone(reward);
                }}
                color="primary"
                disabled={!permissions.canEdit}
              >
                <FileCopyIcon />
              </IconButton>
            </span>
          </Tooltip>
        </CardContent>
      </Card>
    );
  }
}

const mapDispatchToProps = {
  messageShow,
  removeReward,
  publishToggle
};

export default withRouter(connect(null, mapDispatchToProps)(RewardCard));

